<mat-dialog-content *ngIf="addUpdateCycleDescriptionForm">
 <form [formGroup]="addUpdateCycleDescriptionForm">
   <div>
     <mat-label><span style="color: red">*  </span>{{'ecase.common.approvalCycle.approvalCycleDescription' | translate}}</mat-label>
     <mat-form-field appearance="outline"  style="width: 100%">
          <textarea matInput type="text" maxlength="200" rows="4"
                    [attr.aria-label]="'ecase.admindashboard.competitions.awardFinalization.manage.cycle.Description' | translate"
                    [formControlName]="'description'"></textarea>
       <mat-error *ngIf="addUpdateCycleDescriptionForm.get('description').errors?.required"> {{ 'ecase.admindashboard.competitions.awardFinalization.manage.cycle.thisFieldIsRequired.error' | translate }}</mat-error>
       <mat-error *ngIf="addUpdateCycleDescriptionForm.get('description').errors?.duplicateDescription"> {{ 'ecase.admindashboard.competitions.awardFinalization.manage.cycle.duplicateDescription.error' | translate }}</mat-error>
     </mat-form-field>
     <p class="counter-style" >{{getTextLength(addUpdateCycleDescriptionForm, 'description')}} / 200 {{'ecase.common.characters' | translate}}</p>
   </div>
 </form>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="eCase-dialog-action-button-align">
    <button mat-raised-button class="eCase-dialog-positive-action-button"
            [disabled]="addUpdateCycleDescriptionForm.invalid " (click)="onConfirm()">
      {{'ecase.common.save' | translate}}</button>

    <button mat-raised-button class="eCase-dialog-negative-action-button" (click)="onClose()">{{'ecase.common.cancel' | translate}}
    </button>
  </div>
</mat-dialog-actions>
